import Vue from 'vue'
// eslint-disable-next-line no-unused-vars
import {Component, Prop, Watch} from 'vue-property-decorator'
// @ts-ignore
import {ActivityStatus} from '@/common/enums'
import {namespace} from 'vuex-class'
// @ts-ignore
import {BLOCK_MODULE_NAMESPACE} from '@/store/block'
// @ts-ignore
import { MaintenanceService } from '@/services'
import {TICKET_GET_CHARACTER_PROBLEMS, TICKET_MODULE_NAMESPACE} from '../../../../store/ticket'
import {APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE, APARTMENT_MODULE_NAMESPACE} from '../../../../store/apartment'
import {EQUIPMENT_BLOCK, EQUIPMENT_PARAMETER, MAINTENANCE_MODULE_NAMESPACE} from "../../../../store/maintenance";
import { AttributeService } from '../../../../services/attribute.service'
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../../store/service-book'
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store'

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({
  components: {
    'profile-table-loader': async () => import('@/containers/profile/loaders/profile-pagination-loader/ProfilePaginationLoader.vue'),
    'filters-loader': async () => import('../../../documents/loaders/document-filters-loader/DocumentFiltersLoader.vue')
  }
})

class BlockEquipmentList extends Vue {
  /* eslint-disable no-undef */

  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>

  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @BlockStore.Getter currentBlockId: number;
  @TicketStore.Getter characterProblems: any;
  @MaintenanceStore.Getter blockEquipmentParameter: any;
  @MaintenanceStore.Getter blockEquipmentData: any;

  @TicketStore.Action(TICKET_GET_CHARACTER_PROBLEMS)
  storeGetCharacterProblems: () => void;
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (param: { blockId: number | number[], key: string }) => Promise<any>
  @MaintenanceStore.Action(EQUIPMENT_BLOCK)
  storeGetBlockEquipments: (resetPage: boolean) => Promise<any>

  @MaintenanceStore.Mutation(EQUIPMENT_BLOCK)
  storeSetEquipmentBlockData: (payload: any) => void;
  @MaintenanceStore.Mutation(EQUIPMENT_PARAMETER)
  storeSetEquipmentParameter: (payload: any) => void;






  dtActivityStatus: ActivityStatus
  dtActiveIndex: number;
  dtSearch: string;
  dtIsLoadingApartment: boolean;
  dtApartment: any[]

  _clearTimeout: any

  /* ===== attribut filter data ======= */
  validFormAttributFilter:boolean
  showAttributFilter:boolean
  FkAttribut:any
  FkAttributOpertor:any
  allFilterAttributs:any[]
  allFilterAttributsOperators:any[]
  dtFilterAttributs:any[]
  dtFilterAttributsOperators:any[]
  attributFilterVal1:string
  attributFilterVal2:string
  attributFilterDate1Formated:string
  attributFilterDate2Formated:string
  attributeService:AttributeService
  AttributFilterDateValue1:boolean
  AttributFilterDateValue2:boolean
  /* ===== attribut filter data ======= */

  pagination: {page:number,rowsPerPage:number}


  /* eslint-disable no-undef */

  constructor (prop) {
    super(prop)
    this.dtActivityStatus = ActivityStatus.NoActivity
    this.dtActiveIndex = 1
    this.dtSearch = null
    this.dtIsLoadingApartment = false
    this.dtApartment = []

    /* ===== attribut filter data ======= */
    this.attributeService = new AttributeService()
    this.AttributFilterDateValue1 = false
    this.AttributFilterDateValue2 = false
    this.attributFilterDate1Formated = '' //this.formatDate(new Date().toISOString().substring(0,10))
    this.attributFilterDate2Formated = '' //this.formatDate(new Date().toISOString().substring(0,10))
    this.validFormAttributFilter = false
    this.showAttributFilter = false
    this.FkAttribut = null
    this.FkAttributOpertor = null
    this.dtFilterAttributs = []
    this.dtFilterAttributsOperators = []
    this.attributFilterVal1 = null
    this.attributFilterVal2 = null
    this.allFilterAttributs = []
    this.pagination = {
      page: 1,
      rowsPerPage: 10
    }
    this.allFilterAttributsOperators = [
      {
        id:1,
        name:'égal à',
        symbol:'=',
        types:['all'],
        nbOfValue:1
      },
      {
        id:2,
        name:'supérieur à',
        symbol:'>',
        types:['number', 'date'],
        nbOfValue:1
      },
      {
        id:3,
        name:'supérieur ou égal à',
        symbol:'>=',
        types:['number', 'date'],
        nbOfValue:1
      },
      {
        id:4,
        name:'inferieur à',
        symbol:'<',
        types:['number', 'date'],
        nbOfValue:1
      },
      {
        id:5,
        name:'inferieur ou égal à',
        symbol:'<=',
        types:['number', 'date'],
        nbOfValue:1
      },
      {
        id:6,
        name:'entre',
        symbol:'<>',
        types:['number', 'date'],
        nbOfValue:2
      },
      {
        id:7,
        name:'contient',
        symbol:'%',
        types:['string'],
        nbOfValue:1
      },
      {
        id:8,
        name:'ne contient pas',
        symbol:'!%',
        types:['string'],
        nbOfValue:1
      },
      {
        id:9,
        name:'différent de',
        symbol:'!=',
        types:['all'],
        nbOfValue:1
      },
    ]
    /* ===== attribut filter data ======= */
  }



  mounted () {
    if(this.isServiceBook)
    {
      if(!this.currentServiceBook.apartment)
      {
        const id = this.$route.params.id
        this.storeGetServiceBook(id).then(r=>{
          this.getEquipmentOnMount(this.currentServiceBook.apartment.id)
        })
      } else {
        this.getEquipmentOnMount(this.currentServiceBook.apartment.id)
      }
    } else {
      this.getEquipmentOnMount()
    }

    /* ===== attribut filter data ======= */
    // get all attributes
    //console.log('Equipement =============>',this.$route)
    this.attributeService.getAttributes({type:'equipment'}).then(response=>{
      //console.log(response)
      this.allFilterAttributs = response

      if(this.attributeFilters.length) {
        this.showAttributFilter = true
        console.log(this.attributeFilters)
        const selected = []
        this.attributeFilters.forEach(el=>selected.push(el.attribut.id))
        const filtrerd = []
        this.allFilterAttributs.map(dtAtt=>{
          if(selected.indexOf(dtAtt.id)===-1){
            filtrerd.push(dtAtt)
          }
        })
        this.dtFilterAttributs = filtrerd
      } else {
        this.dtFilterAttributs = this.allFilterAttributs
      }
    })
    /* ===== attribut filter data ======= */
  }

  getEquipmentOnMount(apartmentId:number=null)
  {
    this.storeSetEquipmentBlockData({
      currentPage: 1,
      list: []
    })
    this.storeSetEquipmentParameter({
      block: this.blockIdFromUrl,
      apartment: apartmentId? [apartmentId] : [],
      disable: false,
      excludeVehicule: true
    })
    this.handleGetEquipment()
    if (!this.characterProblems || this.characterProblems.level_1.length === 0) {
      this.storeGetCharacterProblems()
    }
  }



  formatDate (date:string):string {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }

  @Watch('pagination',{deep:true})
  paginationHandler(val:{page:number,rowsPerPage:number})
  {
    this.storeSetEquipmentBlockData({
      currentPage: val.page,
      list: [],
      limit:val.rowsPerPage
    })
    this.handleGetEquipment()
  }

  @Watch('attributFilterVal1')
  attributFilterVal1Changed(date){
    this.attributFilterDate1Formated = this.formatDate(date)
  }

  @Watch('attributFilterVal2')
  attributFilterVal2Changed(date){
    this.attributFilterDate2Formated = this.formatDate(date)
  }




  /* ===== attribut filter data ======= */
  @Watch('FkAttribut')
  FkAttributChanged(val)
  {
    if(val)
    {
      //console.log(val)
      const attributType = val.attribute_type.type
      this.dtFilterAttributsOperators = this.allFilterAttributsOperators.filter(item=>item.types.includes('all') || item.types.includes(attributType))
    } else {
      this.FkAttributOpertor = null
      this.attributFilterVal1 = null
      this.attributFilterVal2 = null
    }
  }

  @Watch('FkAttributOpertor')
  FkAttributOpertorChanged(val)
  {
    if(val){}else{
      this.attributFilterVal1 = null
      this.attributFilterVal2 = null
      this.AttributFilterDateValue1 = false
      this.AttributFilterDateValue2 = false
    }
  }
  truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + '...'
  }
  AddAttributFilter()
  {
    this.attributeFilters.push({
      attribut:this.FkAttribut,
      operator:this.FkAttributOpertor,
      value1:this.attributFilterVal1,
      value2:this.attributFilterVal2
    })
    // === delete selected attribut
    const filtred = this.dtFilterAttributs.filter(item=>item.id!==this.FkAttribut.id)
    this.dtFilterAttributs = filtred
    this.FkAttribut = null
    this.storeSetEquipmentParameter({attributeFilters: JSON.stringify(this.attributeFilters)})
  }
  ApplyAttributeFilters()
  {
    this.handleGetEquipment(true)
  }
  removeFilter(index)
  {
    //console.log(this.attributeFilters[index])
    // == add attribut to list
    this.dtFilterAttributs.push(this.attributeFilters[index].attribut)
    this.attributeFilters.splice(index, 1)
    this.storeSetEquipmentParameter({attributeFilters: JSON.stringify(this.attributeFilters)})
  }
  get attributeFilters (): any[] {
    return JSON.parse(this.blockEquipmentParameter.attributeFilters)
  }
  /* ===== attribut filter data ======= */





  @Watch('blockEquipmentParameter.q')
  handleCharPbChanged (value) {
    this.handleGetEquipment(true)
  }

  get lblSetting () {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/equipment').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get Loading (): boolean {
    return this.blockEquipmentData.loading
  }

  get Total (): number {
    return this.blockEquipmentData.total
  }

  get TotalPage (): number {
    return Math.ceil(this.blockEquipmentData.total / 10)
  }

  get Page (): number {
    return this.blockEquipmentData.currentPage
  }

  set Page (page) {
    this.storeSetEquipmentBlockData({currentPage: page})
    this.handleGetEquipment()
  }



  get Disabled (): boolean {
    return this.blockEquipmentParameter.disable
  }

  set Disabled (val) {
    this.storeSetEquipmentParameter({disable: val})
    this.handleGetEquipment(true)
  }

  get Apartment (): number[] {
    return this.blockEquipmentParameter.apartment
  }

  set Apartment (val) {
    this.storeSetEquipmentParameter({apartment: val})
    this.handleGetEquipment(true)
  }

  get CharPb1 (): number {
    return this.blockEquipmentParameter.char1
  }

  set CharPb1 (val) {
    if (val !== this.blockEquipmentParameter.char1) {
      this.storeSetEquipmentParameter({char1: val})
      this.storeSetEquipmentParameter({char2: null})
      this.handleGetEquipment(true)
    }
  }

  get CharPb2 (): number {
    return this.blockEquipmentParameter.char2
  }

  set CharPb2 (val) {
    if (val !== this.blockEquipmentParameter.char2) {
      this.storeSetEquipmentParameter({char2: val})
      this.handleGetEquipment(true)
    }
  }

  get blockId (): number[] {
    return [this.blockIdFromUrl]
  }

  get blockIdFromUrl (): number {
    if(this.$route.path.includes('service-book'))
    {
      return parseInt(this.currentServiceBook.apartment.fk_apartment_block)
    }
    return parseInt(this.$route.params.id)
  }

  get isLoading (): boolean {
    console.log(this.dtActivityStatus, 'dtActivityStatus')
    return this.dtActivityStatus === ActivityStatus.Loading
  }

  get coSource () {
    return this.blockEquipmentData.list || []
  }

  get coApartments () {
    return (this.dtApartment || []).map(x => {
      return {
        value: x.id,
        text: x['location_number'] ? x['location_number'] + ' / ' + x['apartment_number'] : x['apartment_number']
      }
    })
  }

  get coCharPbs1 () {
    let categories = this.characterProblems.level_1.map(lvl1 => ({value: lvl1.id, text: lvl1.name}))
    return categories.filter(cat=>cat.value!==238) // hide vehicule categorie
  }

  get coCharPbs2 () {
    if (!this.CharPb1) return []
    return this.characterProblems.level_1
      .find(x => x.id === this.CharPb1).level_2
      .map(lvl1 => ({value: lvl1.id, text: lvl1.name}))
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }

  resetFilters () {
    this.CharPb1 = null
    this.CharPb2 = null
    this.Apartment = this.isServiceBook ? [this.currentServiceBook.apartment.id]:[]
    this.Disabled = false

    /* ===== attribut filter data ======= */
    this.storeSetEquipmentParameter({attributeFilters: JSON.stringify([])})
    this.dtFilterAttributs = this.allFilterAttributs
    this.showAttributFilter = false
    /* ===== attribut filter data ======= */
  }

  onChangeApartment (val) {}

  setLoaderApartment (value: boolean) {
    this.dtIsLoadingApartment = value
  }

  handleGetEquipment (needReset: boolean = false) {
    /* clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeGetBlockEquipments(needReset).then(() => {})
    }, 500) */
    this.storeGetBlockEquipments(needReset).then(() => {})
  }

  handleApartmentRemoteFetch (key: string, cb: Function, loading: Function) {
    const param: any = {
      key: key,
      blockId: this.blockEquipmentParameter.block// this.searchParam.block
    }
    this.storeGetApartmentsAutocomplete(param)
      .then(res => {
        cb((res || []).map(x => ({
          value: x.id, text: x.apartment_number
        })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  handleEquipmentClick (equipment) {
    /* this.$router.push({
      path: `/block/${this.$route.params.id}/equipment/${equipment.id}`,
      params: {
        id: this.$route.params.id,
        cid: equipment.id
      }
    }) */
    if(this.$route.path.includes('service-book'))
    {
      this.$router.push(`/service-book/${this.$route.params.id}/equipments/${equipment.id}`)
    }else{
      this.$router.push(`/block/${this.$route.params.id}/equipment/${equipment.id}`)
    }
  }

  formatAcronym (item) {
    return item.substring(0, 2)
  }

  get coTableHeaders (): any[] {
    return [
      {
        // text: 'avatar',
        value: 'avatar',
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.equipmentHeaders.name),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.equipmentHeaders.description),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: `${this.$t(this.lblSetting.equipmentHeaders.charPb1)} & ${this.$t(this.lblSetting.equipmentHeaders.charPb2)}`,
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.blockHeaderApartment),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.equipmentHeaders.location),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.equipmentHeaders.follow),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      }
    ]
  }
}

export default BlockEquipmentList



// WEBPACK FOOTER //
// ./src/containers/block/components/block-equipment-list/index.ts